import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import axios from 'axios';

const Checkout = () => {
    const navigate = useNavigate();
    const { cartItems, getCartTotal, clearCart } = useCart();
    const [showRes, setShowRes] = useState('');
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        postcode: '',
        country: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        let newErrors = {};

        if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
        if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is invalid";
        }

        if (!formData.phone.trim()) newErrors.phone = "Phone is required";
        if (!formData.address.trim()) newErrors.address = "Address is required";
        if (!formData.city.trim()) newErrors.city = "City is required";
        if (!formData.postcode.trim()) newErrors.postcode = "Postcode is required";
        if (!formData.country.trim()) newErrors.country = "Country is required";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            setLoading(true);
            const formDataToSend = new FormData();
            formDataToSend.append("order_billing_country", formData.country);
            formDataToSend.append("order_billing_fname", formData.firstName);
            formDataToSend.append("order_billing_lname", formData.lastName);
            formDataToSend.append("order_billing_address", formData.address);
            formDataToSend.append("order_billing_city", formData.city);
            formDataToSend.append("order_billing_state", formData.city);
            formDataToSend.append("order_billing_zip_code", formData.postcode);
            formDataToSend.append("order_billing_phone", formData.phone);
            formDataToSend.append("order_billing_email", formData.email);
            cartItems.forEach((item, index) => {
                formDataToSend.append(`items[${index}][product_id]`, item.id);
                formDataToSend.append(`items[${index}][product_qty]`, item.quantity);
            });

            const res = await axios.post(
                "https://roughradio.demo-customproject.com/backend/api/cart/ajax_save_order_api",
                formDataToSend,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            if (res?.data?.status === true) {
                setShowRes(res?.data)
                setFormData({ firstName: '', lastName: '', email: '', phone: '', address: '', city: '', postcode: '', country: '' })
                setTimeout(() => {
                    clearCart();
                    navigate('/thankyou');
                }, 1000);
            } else {
                setShowRes(res?.data)
            }
        } catch (error) {
            console.error("Order Error:", error);
            alert("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (cartItems.length === 0) {
        navigate('/shop');
        return null;
    }

    return (
        <section className="checkout-pg-sc">
            <div className="container-fluid ps-5 pe-5">
                <div className="row">
                    <div className="col-md-12">
                        <div className="shedule-head">
                            <div className="un-head wow bounceInUp">
                                <h3>CHECKOUT</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-7">
                        <div className="checkout-form">
                            <h5>Billing Information</h5>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>First Name *</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}

                                            />
                                            {errors.firstName && <small className="error">{errors.firstName}</small>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Last Name *</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}

                                            />
                                            {errors.lastName && <small className="error">{errors.lastName}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Email *</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && <small className="error">{errors.email}</small>}

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Phone *</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                            />
                                            {errors.phone && <small className="error">{errors.phone}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Address *</label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                    />
                                    {errors.address && <small className="error">{errors.address}</small>}
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>City *</label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={formData.city}
                                                onChange={handleChange}
                                            />
                                            {errors.city && <small className="error">{errors.city}</small>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Postcode *</label>
                                            <input
                                                type="text"
                                                name="postcode"
                                                value={formData.postcode}
                                                onChange={handleChange}
                                            />
                                            {errors.postcode && <small className="error">{errors.postcode}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Country *</label>
                                    <input
                                        type="text"
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                    />
                                    {/* <select
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="United States">United States</option>
                                        <option value="Canada">Canada</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Other">Other</option>
                                    </select> */}
                                    {errors.country && <small className="error">{errors.country}</small>}
                                </div>
                                <button
                                    type="submit"
                                    className="checkout-submit-btn"
                                    disabled={loading}
                                >
                                    {loading ? "Placing Order..." : "Place Order"}
                                </button>
                            </form>
                            {showRes && (
                                <div className={`showRes_noti ${showRes.status === true ? "green" : "red"}`}>
                                    <span>{showRes?.message}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="checkout-summary">
                            <h5>Order Summary</h5>
                            <div className="checkout-items">
                                {cartItems.map((item) => (
                                    <div key={item.id} className="checkout-item">
                                        <div className="checkout-item-image">
                                            <img src={item.image} alt={item.name} />
                                        </div>
                                        <div className="checkout-item-details">
                                            <p className="item-name">{item.name}</p>
                                            <p className="item-qty">Qty: {item.quantity}</p>
                                        </div>
                                        <div className="checkout-item-price">
                                            <p>£{(item.price * item.quantity).toFixed(2)}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="summary-divider"></div>
                            <div className="summary-row">
                                <span>Subtotal</span>
                                <span>£{getCartTotal().toFixed(2)}</span>
                            </div>
                            <div className="summary-row">
                                <span>Shipping</span>
                                <span className="free-shipping">FREE</span>
                            </div>
                            <div className="summary-divider"></div>
                            <div className="summary-row total">
                                <span>Total</span>
                                <span>£{getCartTotal().toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Checkout;
